/**
 * @generated SignedSource<<ea4a67cd799b583111f2a0e97bc696ce>>
 * @relayHash 348979b6d4852cfc2dcc9cbeaa57e107
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 68c72f13a01f2451f188338225b4019f758a8369e559f30beb6142c690fb05bb

import type { ConcreteRequest } from 'relay-runtime';
export type useRovoActivationIdQuery$variables = {
  cloudId: string;
  shouldResolveActivation: boolean;
};
export type useRovoActivationIdQuery$data = {
  readonly tenantContexts?: ReadonlyArray<{
    readonly activationIdByProduct: {
      readonly active: string | null;
    } | null;
  } | null> | null;
};
export type useRovoActivationIdQuery = {
  response: useRovoActivationIdQuery$data;
  variables: useRovoActivationIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldResolveActivation"
  }
],
v1 = [
  {
    "condition": "shouldResolveActivation",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          {
            "items": [
              {
                "kind": "Variable",
                "name": "cloudIds.0",
                "variableName": "cloudId"
              }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
          }
        ],
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "product",
                "value": "rovo"
              }
            ],
            "concreteType": "TenantContextActivationId",
            "kind": "LinkedField",
            "name": "activationIdByProduct",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "active"
              }
            ],
            "storageKey": "activationIdByProduct(product:\"rovo\")"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useRovoActivationIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRovoActivationIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "68c72f13a01f2451f188338225b4019f758a8369e559f30beb6142c690fb05bb",
    "metadata": {},
    "name": "useRovoActivationIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7c2eb7120d071cce4386ff814335ec18";

export default node;
